/**
 * The first-run tour's shape, kept pure so it can be tested without a DOM.
 *
 * Someone who arrived through a friend's invite link already knows why they
 * are here: they skip the "give your toiyp" card, the invite step and the
 * share kit, and
 * land on their blank letter to that friend once the tour is done.
 */

export type HowCard = 'address' | 'post' | 'trust';
export type FirstRunStep = 'how' | 'face' | 'invite' | 'share' | 'done';

export const ALL_HOW_CARDS: readonly HowCard[] = ['address', 'post', 'trust'];

export function howCards(viaInviteLink: boolean): HowCard[] {
  return viaInviteLink ? ['post', 'trust'] : [...ALL_HOW_CARDS];
}

export function firstRunSteps(viaInviteLink: boolean): FirstRunStep[] {
  // Invite-link arrivals came to write to one person: the share kit can wait
  // (it is in the ⋯ menu and on the profile whenever they want it).
  return viaInviteLink ? ['how', 'face', 'done'] : ['how', 'face', 'invite', 'share', 'done'];
}
